var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "typcn:warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8782 11.5481L11.4442 4.15756C10.8622 3.18781 9.97198 2.63281 8.99998 2.63281C8.02798 2.63281 7.13773 3.18781 6.55573 4.15606L2.12173 11.5481C1.53223 12.5298 1.46773 13.5768 1.94548 14.4206C2.42248 15.2651 3.35398 15.7496 4.49998 15.7496H13.5C14.646 15.7496 15.5775 15.2651 16.0545 14.4213C16.5315 13.5776 16.4677 12.5306 15.8782 11.5481ZM8.99998 13.1613C8.35948 13.1613 7.83748 12.6401 7.83748 11.9996C7.83748 11.3583 8.35873 10.8363 8.99998 10.8363C9.64123 10.8363 10.1625 11.3583 10.1625 11.9996C10.1625 12.6401 9.64048 13.1613 8.99998 13.1613ZM10.2247 7.59331C10.2165 7.61656 9.17398 10.1943 9.17398 10.1943C9.14548 10.2648 9.07648 10.3113 9.00073 10.3113C8.92498 10.3113 8.85598 10.2648 8.82748 10.1943L7.78423 7.61581C7.72163 7.45953 7.68881 7.29291 7.68748 7.12456C7.68748 6.40081 8.27623 5.81206 8.99998 5.81206C9.21254 5.81261 9.4218 5.86471 9.6098 5.96391C9.7978 6.0631 9.95893 6.20643 10.0794 6.38158C10.1998 6.55674 10.2759 6.7585 10.3013 6.96955C10.3266 7.1806 10.3003 7.39464 10.2247 7.59331Z",
    fill: "#FFD700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.48f8718df4453528458f158e2d9f1260.svg";
export { ForwardRef as ReactComponent };